import headerImage from '../static/cloneBold.jpg';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import { Input, Button } from '@material-ui/core';
import { useState } from 'react';
import {auth} from './FirebaseConfig';
import './styles/Modals.css';

function getModalStyle() {
    const top = 50;
    const left = 50;
  
    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
}
  
const useStyles = makeStyles((theme) => ({
    paper: {
      position: 'absolute',
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: '2px solid #000',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
}));

const ModalSignUp = ({open, setOpen, setUname}) => {
    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const signUp = (e) =>{
        e.preventDefault();
        setUname(username);
        auth.createUserWithEmailAndPassword(email, password)
        .then((authUser) => {
            return authUser.user.updateProfile({
                displayName : username
            });
        })
        .catch((error) => alert(error.message));
        setOpen(false);
    }



    return(
            <Modal className = 'modal'
                open={open}
                onClose={() => {setOpen(false)}}>     

                <div style={modalStyle} className={classes.paper}>
                    <form className = 'modal_form'>
                        <center>
                            <img className = 'app_headerImage'
                            src = {headerImage}
                            alt = 'InstaLogo'/>
                        </center> 
                        <Input
                            type = 'text'
                            placeholder = 'Username'
                            value = {username}
                            onChange = {(e) => setUsername(e.target.value)}
                        />
                        <Input
                            type = 'text'
                            placeholder = 'Email'
                            value = {email}
                            onChange = {(e) => setEmail(e.target.value)}
                        />
                        <Input
                            type = 'password'
                            placeholder = 'Password'
                            value = {password}
                            onChange = {(e) => setPassword(e.target.value)}
                        />
                        <Button type = 'submit' onClick = {signUp}>Sign Up</Button>
                    </form>
                </div>
            </Modal>
    );
}


const ModalSignIn = ({openSignIn, setOpenSignIn}) => {
    const classes = useStyles();
    const [modalStyle] = useState(getModalStyle);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const signIn = (e) =>{
        e.preventDefault();
        auth.signInWithEmailAndPassword(email, password)
        .catch((error) => alert(error.message));
        setOpenSignIn(false);
    }


    return(
            <Modal className = 'modal'
                open={openSignIn}
                onClose={() => {setOpenSignIn(false)}}>     

                <div style={modalStyle} className={classes.paper}>
                    <form className = 'modal_form'>
                        <center>
                            <img className = 'app_headerImage'
                            src = {headerImage}
                            alt = 'InstaLogo'/>
                        </center> 
                        <Input
                            type = 'email'
                            placeholder = 'Email'
                            value = {email}
                            onChange = {(e) => setEmail(e.target.value)}
                        />

                        <Input
                            type = 'password'
                            placeholder = 'Password'
                            value = {password}
                            onChange = {(e)=> setPassword(e.target.value)}
                        />
                        <Button type = 'submit' onClick = {signIn}>Sign In</Button>
                    </form>
                </div>
            </Modal>

    );
}

export {ModalSignIn, ModalSignUp};

            